import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService } from 'kea-resource';

const controller = rpcController("CajaRuta");
const crud = rpcCrudService<models.CajaRuta, models.CajaRutaDTO>(controller);

export const CajaRuta = cacheResource({
    ...crud,
    queryNoMemo: crud.query,
    /**Consulta los status de una caja */
    ConsultarStatus: async (filtro: models.FiltroStatusCajaRuta): Promise<models.StatusCajaRutaViewDto[]> => await controller('ConsultarStatus', {}, filtro),

    /**Conecta una caja a un camion */
    ConectarCaja: async (idCaja: number, idCamion: number): Promise<void> => await controller('ConectarCaja', { idCaja, idCamion }),

    /**Desconecta una caja de un camion */
    DesconectarCaja: async (idCaja: number): Promise<void> => await controller('DesconectarCaja', { idCaja }),

    /**
     * Asigna una caja a un camion
     * @param idCaja 
     * @param idCamion 
     */
    AsignarCaja: async (idCaja: number, idCamion: number): Promise<void> => await controller('AsignarCaja', { idCaja, idCamion }),

    /**Asigna una caja a una sucursal */
    AsignarCajaSucursal: async (idCaja: number, idSucursal: number): Promise<void> => await controller('AsignarCajaSucursal', { idCaja, idSucursal }),

    /**Obtiene para todos los camiones, las cajas que estan conectadas a ese camion */
    ConsultaCajasConectadas: async (): Promise<models.CamionCajasConectadas[]> => await controller('ConsultaCajasConectadas', {}),
    
    /**Obtiene el reorte de manifiesto de caja */
    ReporteDeManifiesto: async (idCaja: number, fecha: Date | string): Promise<string> => await controller('ReporteDeManifiesto', { idCaja, fecha }),

    query2: async (): Promise<models.CajaRutaDTO[]> => await controller('Query2', {}), 

    get2: async (id: number): Promise<models.CajaRutaDTO> => await controller('Get2', {id}),

}, {
        queryNoMemo: false
    }, {
        AsignarCaja: true,
        ConectarCaja: true,
        DesconectarCaja: true,
        AsignarCajaSucursal: true,
        query2 :true,
        get2: true
    });

const e = CajaRuta;




// WEBPACK FOOTER //
// ./app/resources/items/cajaruta.tsx